import { Component } from '@angular/core';
import { FieldType, FieldTypeConfig } from '@ngx-formly/core';
import { AutoComplete, AutoCompleteModule } from 'primeng/autocomplete';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'app-formly-project-autocomplete',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    AutoCompleteModule,
    FormlyModule,
  ],
  template: `
    <div class="field">
      @if (props.label) {
      <label [for]="field.key" class="block mb-2">
        {{ props.label }}
        @if (props.required) {
        <span class="text-red-500">*</span>
        }
      </label>
      }
      <p-autocomplete
        styleClass="project-ac"
        [multiple]="true"
        [forceSelection]="props.forceSelection === false ? false : true"
        [suggestions]="props.suggestions"
        [formControl]="formControl"
        [formlyAttributes]="field"
        [field]="props.field"
        [dropdown]="props.dropdown"
        [style]="{ width: '100%' }"
        (completeMethod)="props.search && props.search(field, $event)"
        (onSelect)="props.onSelect && props.onSelect($event)"
        [placeholder]="props.placeholder || 'Keresés...'">
      </p-autocomplete>
    </div>
  `,
})
export class FormlyProjectAutoCompleteComponent extends FieldType<FieldTypeConfig> {
  ngOnInit(): void {
    const isMultiple = this.props?.multiple !== false;
    const val = this.formControl?.value;
    if (isMultiple) {
      if (val == null) {
        this.formControl.setValue([], { emitEvent: false });
      } else if (!Array.isArray(val)) {
        this.formControl.setValue([val], { emitEvent: false });
      }
    }
    if (!this.props.suggestions) {
      this.props.suggestions = [];
    }
  }
}